import React from 'react'
import { EmailNotificationsForm, EmailNotificationsFields } from './EmailNotificationsForm'
import { UserRepository } from 'repository/user'

export const ConnectedEmailNotificationsForm: React.FC = () => {
  const onSubmit = (body: EmailNotificationsFields) => {
    return UserRepository.updateNotificationPreferences(body)
  }

  return <EmailNotificationsForm onSubmit={onSubmit} />
}
